import { sendAbTestingHit } from '/Foundation/ABTesting/code/Views/Foundation/ABTesting/abTestingClient.js';
import { attachVideoToggles } from '/Foundation/Common/code/Views/Foundation/Common/VideoToggle';

const SELECTOR = '.hero-component .text-box[data-ab-cta-position="1"]';

function attach() {
  document.querySelectorAll<HTMLElement>(SELECTOR).forEach((box) => {
    box.addEventListener('click', () => {
      sendAbTestingHit('hero_component_CTA_clicks_position_1');
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  attach();
  attachVideoToggles();
});
